import React, { useState, useEffect } from 'react';
import { log } from '../helper';

const NumberPad = ({ setValue }) => {
  const [inputValue, setInputValue] = useState(''); // Store the current input value

  useEffect(() => {
    log(inputValue, '- Has changed')
    console.log(inputValue, '- Has changed')
    setValue(inputValue);
  }, [inputValue])

  // Handle number button click
  const handleNumberClick = (e, number) => {
    e.preventDefault();
    setInputValue((prev) => prev + number); // Append the number to the input
  };

  // Handle delete/backspace button click
  const handleDelete = (e) => {
    e.preventDefault();
    setInputValue((prev) => prev.slice(0, -1)); // Remove the last character
  };

  // Handle clear button click
  const handleClear = (e) => {
    e.preventDefault();
    setInputValue(''); // Clear the input
  };

  const handlePasswordChange = (e) => {
    setInputValue(e.target.value)
    setValue(inputValue)
  };

  return (
    <div>
      {/* Display Input Value */}
      <div className="form-group mb-4 text-center">
        <input
          type="number"
          className="form-control text-center"
          value={inputValue}
          placeholder="Enter numbers"
          onChange={handlePasswordChange}
        />
      </div>
      <div className="container">
      </div>

      <div className="container text-center">
        {/* Number Pad Buttons */}
        <div className="d-inline-flex flex-wrap justify-content-center align-items-center" style={{ width: '228px' }}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
            <button
              key={number}
              className="btn btn-outline-primary m-2 fw-bold"
              style={{ width: '60px', height: '60px' }}
              onClick={(e) => handleNumberClick(e, number.toString())}
            >
              {number}
            </button>
          ))}
          {/* Clear Button */}
          <button
            className="btn btn-outline-danger m-2 fw-bold"
            style={{ width: '60px', height: '60px' }}
            onClick={handleClear}
          >
            Clear
          </button>

          {/* Zero Button */}
          <button
            className="btn btn-outline-primary m-2 fw-bold"
            style={{ width: '60px', height: '60px' }}
            onClick={(e) => handleNumberClick(e, '0')}
          >
            0
          </button>

          {/* Backspace Button */}
          <button
            className="btn btn-outline-warning m-2 fw-bold"
            style={{ width: '60px', height: '60px' }}
            onClick={handleDelete}
          >
            Del
          </button>


        </div>
      </div>
    </div>
  );
};

export default NumberPad;